import React from 'react'

function Avatar({ rounded = false, size, src }) {

    let actualSize = "size-8";

    if (size === "md") {
        actualSize = "size-[38px]"
    }
    else if (size === "lg") {
        actualSize = "size-[46px]"
    }
    else if (size === "xl") {
        actualSize = "size-[62px]"
    }

    return (
        <div className='relative shadow-md shadow-white/5'>
            <img src={src} alt="" className={`${actualSize}  ${rounded ? 'rounded-full' : 'rounded-md'} object-cover`} />
        </div>
    )
}

export default Avatar